import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["onSwiper"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Controller, Navigation, Pagination, Scrollbar, A11y, EffectFade } from "swiper/core";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
SwiperCore.use([Autoplay, Controller, Navigation, Pagination, Scrollbar, A11y, EffectFade]);
function SliderCore(_ref) {
  let {
      onSwiper
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    children,
    sliderOptions = {}
  } = props;
  // 複数行にする場合はslidesPerColumnを指定する
  const handleSwiper = useCallback(control => {
    if (onSwiper) {
      onSwiper(control);
    }
  }, [onSwiper]);
  return /*#__PURE__*/_jsx(Swiper, _objectSpread(_objectSpread({}, sliderOptions), {}, {
    onSwiper: handleSwiper,
    children: React.Children.map(children, (item, i) => /*#__PURE__*/_jsx(SwiperSlide, {
      children: item
    }, `swiper-slide-${i}`))
  }));
}
export default SliderCore;